









































































































































































import Vue, { VueConstructor } from "vue";
import { mapState, mapActions, mapMutations } from "vuex";
import { trackEvent } from "@/js/tracking/gtag";
import {
  PostScoreRequest,
  PostScoreResponse
} from "@/common/api/leaderboard/PostScore";
import { Record } from "@/common/api/leaderboard/Record";
import { Actions, Mutations } from "../store/leaderboard";
import { share, embed } from "@/js/social/facebook";
import { sharetwitter } from "@/js/social/twitter";
import ShareButtons from "@/components/ShareButtons.vue";

interface Refs {
  $refs: {
    initials: HTMLInputElement;
  };
}

interface Store {
  postScore(data: PostScoreRequest): Promise<PostScoreResponse>;
  setCurrentScoreData(data: Record): void;
  currentScore: Record;
}
interface Data {
  initials: string;
  submitting: boolean;
  submitted: boolean;
  err: string;
}
export default (Vue as VueConstructor & Store & Data & Refs).extend({
  components: {
    ShareButtons
  },
  data(): Data {
    return { initials: "", submitting: false, submitted: false, err: "" };
  },
  computed: {
    ...mapState("leaderboard", ["currentScore"])
  },
  mounted() {
    (this.$refs.initials as HTMLInputElement).focus();
  },
  methods: {
    ...mapActions("leaderboard", {
      fetchLeaderboard: Actions.FETCH,
      postScore: Actions.POST_SCORE
    }),
    ...mapMutations("leaderboard", {
      setCurrentScoreData: Mutations.SET_CURRENT_RECORD
    }),
    canPost(): boolean {
      return this.initials.length >= 2 && this.initials.length <= 3;
    },
    onInput(e: any): void {
      let val: string = e.target.value.replace(/[^a-z]*/gi, "").toUpperCase();
      this.initials = val;
      e.target.value = val;
    },
    async onSubmitInitials(): Promise<void> {
      this.setCurrentScoreData({
        ...this.currentScore,
        initials: this.initials
      });
      try {
        this.submitting = true;
        this.err = "";
        const res = await this.postScore(this.currentScore);
        if (res.success) {
          this.submitted = true;
          console.log("Post successful.");
          trackEvent("post_score");
          // this.postMsg = "Post Successful!";
        }
      } catch (err) {
        this.err =
          "There was a problem posting your score. Please try again later.";
        console.log("There was an error posting the score.");
      }
      this.submitting = false;
    }
  }
});
